import * as XLSX from '@e965/xlsx';

// Reads a .csv/.xls/.xlsx File into { headers, rows }. `rows` is an array of arrays,
// positionally aligned with `headers` — mapping is done by column index, not header text,
// so the admin's remapping choices don't depend on exact header spelling.
export function parseSpreadsheetFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read the file.'));
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'array' });
        const sheet = wb.Sheets[wb.SheetNames[0]];
        const grid = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false, defval: '' });
        if (!grid.length) { resolve({ headers: [], rows: [] }); return; }
        const headers = grid[0].map((h, i) => (h ?? '').toString().trim() || `Column ${i + 1}`);
        const rows = grid.slice(1)
          .filter(r => r.some(cell => (cell ?? '').toString().trim() !== ''))
          .map(r => headers.map((_, i) => (r[i] ?? '').toString().trim()));
        resolve({ headers, rows });
      } catch (err) {
        reject(new Error('Could not parse this file. Make sure it\'s a valid .csv or .xlsx file.'));
      }
    };
    reader.readAsArrayBuffer(file);
  });
}
